<template lang="pug">
.feedback-form
        .form-legend {{ feedbackTitle }}
            button.close-form(@click="hideFeedback")
        .feedback-form-input-container(:class="{ required: feedbackForm.dirty('name') && feedbackForm.invalid('name') }")
            input.aiq-input(placeholder="Name*",
                            @focusout="handleFocus('name')",
                            @input="handleInput('name', $event)",
                            @keyup="handleInput('name', $event)",
                            v-model="user.name")
        .feedback-form-input-container(:class="{ required: feedbackForm.dirty('email') && feedbackForm.invalid('email')  }")
            input.aiq-input(placeholder="Email*",
                            @focusout="handleFocus('email')",
                            @input="handleInput('email', $event)",
                            @keyup="handleInput('email', $event)",
                            v-model="user.email")
        .feedback-form-input-container.feedback-form-textarea-container(:class="{ required: feedbackForm.dirty('message') && feedbackForm.invalid('message') }")
            .aiq-message(contenteditable="true",
                            id="message",
                            @focusout="handleFocus('message')",
                            @input="handleInput('message', $event)",
                            @keyup="handleInput('message', $event)",
                            placeholder="Message*")
        .feedback-form-hours {{ agentHours }}
        .feedback-form-actions
            button.send-email(type="submit", @click="onSubmit", :disabled="!formClear") Send Email
            .sending-spinner(v-if="sending")
                .sk-circle1.sk-child
                .sk-circle2.sk-child
                .sk-circle3.sk-child
                .sk-circle4.sk-child
                .sk-circle5.sk-child
                .sk-circle6.sk-child
                .sk-circle7.sk-child
                .sk-circle8.sk-child
                .sk-circle9.sk-child
                .sk-circle10.sk-child
                .sk-circle11.sk-child
                .sk-circle12.sk-child
            .feedback-form-copyright Powered by Agent IQ
</template>

<script>
import get from 'lodash/get';
import { FormInput, Rules, Form } from './form-validation';

const moment = require('moment-timezone/builds/moment-timezone-with-data-2012-2022.min');

export default {
  name: 'postchat-component',
  props: {
    message: {
      type: String,
      default: () => '',
    },
    sending: {
      type: Boolean,
      deafult: () => false,
    },
    customer: {
      type: Object,
    },
    payload: {
      type: Object,
    },
  },

  computed: {
    agentHours() {
      if (get(this, 'payload.live_hours.show_to_customer')) {
        return this.payload.message.live_hours;
      }

      return '';
    },
    feedbackTitle() {
      if (get(this, 'payload.message.header')) {
        const { end_time, start_time, time_zone, weekday } = this.payload.live_hours;
        const weekdayNow = moment().tz(time_zone).format('dddd').toLowerCase();
        const hour = moment().tz(time_zone).format('HH');

        if (weekday[weekdayNow] && hour >= start_time && hour < end_time) {
          return this.payload.message.header.live_hours;
        }
        return this.payload.message.header.non_live_hours;
      }

      return '';
    },
  },

  data() {
    return {
      user: {},
      feedbackForm: null,
      feedbackFormData: {
        name: true,
        email: true,
        message: true,
      },
      formClear: false,
      feedbackMessage: null,
      message: '',
      customer: null,
      sending: null,
      payload: null,
    };
  },
  created() {
    this.registerFormElements();
  },
  mounted() {
    this.$el.querySelector('#message').innerHTML = this.message;
    this.user = {
      question: this.message,
      name: [
        get(this.customer, 'profile.first_name', ''),
        get(this.customer, 'profile.last_name', ''),
      ].join(' ').trim(),
      email: get(this.customer, 'profile.email', ''),
    };
    this.feedbackForm.inputs.email.value = this.user.email;
    this.feedbackForm.inputs.name.value = this.user.name;
    this.feedbackForm.inputs.message.value = this.message;
    this.feedbackForm.getInput('message').setValid();
    this.feedbackForm.validate();
    this.updateFormElements();
  },
  methods: {
    onSubmit(e) {
      if (!this.formClear) {
        e.preventDefault();
      } else {
        const user = Object.assign ? Object.assign({}, this.user) : this.user;
        user.email = user.email.trim();
        this.$emit('submit', user);
        this.user = {};
        this.clearMessage();
        this.updateFormElements();
      }
    },

    clearMessage() {
      this.$el.querySelector('#message').innerHTML = '';
    },

    handleInput(name, $event) {
      const content = $event.target.innerHTML || $event.target.value;
      name === 'message' && (this.user.question = content);
      this.feedbackForm.inputs[name].value = content;
      this.updateFormElements();
    },

    handleFocus(name) {
      this.feedbackForm.inputs[name].setDirty();
      this.feedbackForm.inputs[name].validate();
      this.updateValid();
    },

    hideFeedback() {
      this.$emit('hideFeedback');
    },

    registerFormElements() {
      this.feedbackForm = new Form(
        [
          new FormInput('name', [Rules.REQUIRED]),
          new FormInput('email', [Rules.REQUIRED, Rules.EMAIL]),
          new FormInput('message', [Rules.REQUIRED]),
        ],
        this,
      );
    },

    updateFormElements() {
      this.feedbackFormData.email = this.feedbackForm.clear('email');
      this.feedbackFormData.name = this.feedbackForm.clear('name');
      this.feedbackFormData.message = this.feedbackForm.clear('message');
      this.updateValid();
    },

    updateValid() {
      const valid = this.feedbackForm.valid('name')
        && this.feedbackForm.valid('email')
        && this.feedbackForm.valid('message');
      this.formClear = valid;
    },
  },
};
</script>

<style lang="scss">
@import "../../aiq-theme/aiq-variables.scss";

input,
textarea {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

[contenteditable=true]:empty:before {
    content: attr(placeholder);
    display: block;
    /* For Firefox */
}

.feedback-form {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: #fff;
    z-index: 10;
}

.form-legend {
    background-color: #0a1a34;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    font-size: 14px;
    height: 54px;
    line-height: 18px;
    margin-bottom: 15px;
    padding: 15px 38px;
    position: relative;
    text-align: left;
}

.feedback-form-input-container {
    display: flex;
    align-items: center;
    height: 42px;
    margin: 10px 15px;
    border-radius: 4px;
    background-color: #f2f6f9;
    transition: box-shadow .15s;
    input {
        width: 100%;
        height: 18px;
        max-height: 18px;
        padding: 0 10px;
        font-size: 15px;
        line-height: 18px;
        border: 0;
        outline: 0;
        background-color: transparent;
        overflow: hidden;
        box-sizing: border-box;

        &::-webkit-input-placeholder {
            color: #757575;
        }
        &::-moz-placeholder {
            color: #757575;
            opacity: 1;
        }
        &:-ms-input-placeholder {
            color: #757575;
            opacity: 1;
        }
        &:-moz-placeholder {
            color: #757575;
        }
    }
    div {
        width: 100%;
        height: 120px;
        padding: 10px 10px 0;
        font-size: 15px;
        line-height: 18px;
        word-break: break-all;
        border: 0;
        background-color: transparent;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: auto;
        outline: 0;
        box-sizing: border-box;
        &::-webkit-scrollbar {
            width: 4px;
        }
        &:hover {
            &::-webkit-scrollbar-track {
                background-color: rgba(85, 85, 85, .1);
            }
            &::-webkit-scrollbar-thumb {
                background-color: rgba(0, 0, 0, .2);
            }
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
            border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: transparent
        }
    }
    &.required {
        box-shadow: inset 0 0 5px 0 #ff0000;
    }
    .placeholder {
        color: #757575;
    }
}
.feedback-form-textarea-container {
    height: 120px;
}
.feedback-form-hours {
    padding: 0 15px;
    color: #67737F;
    font-size: 12px;
}

.send-email {
    float: right;
    min-width: 102px;
    height: 36px;
    padding: 0;
    margin: 10px 10px 5px 0;
    color: #fff;
    font-size: 14px;
    line-height: 36px;
    border: 0;
    border-radius: 4px;
    background-color: #19acfd;
    outline: 0;
    cursor: pointer;
}

.send-email[disabled] {
    color: #a0a0a0;
    font-size: 14px;
    background-color: #ccc;
}

.close-form {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 10px;
    height: 10px;
    padding: 0;
    margin: 0;
    border: 0;
    outline: 0;
    background-color: transparent;
    cursor: pointer;
}

.feedback-form-copyright {
    padding-right: 10px;
    color: $aiq-webchat-ligher-text;
    font-size: 10px;
    text-align: right;
    clear: both;
}

.sending-spinner {
    position: relative;
    float: right;
    width: 42px;
    height: 42px;
    margin-right: 10px;
}

.sending-spinner .sk-child {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.sending-spinner .sk-child:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #19acfd;
    border-radius: 100%;
    -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
    animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
}
.sending-spinner .sk-circle2 {
    -webkit-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    transform: rotate(30deg); }
.sending-spinner .sk-circle3 {
    -webkit-transform: rotate(60deg);
    -ms-transform: rotate(60deg);
    transform: rotate(60deg);
}
.sending-spinner .sk-circle4 {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
}
.sending-spinner .sk-circle5 {
    -webkit-transform: rotate(120deg);
    -ms-transform: rotate(120deg);
    transform: rotate(120deg);
}
.sending-spinner .sk-circle6 {
    -webkit-transform: rotate(150deg);
    -ms-transform: rotate(150deg);
    transform: rotate(150deg);
}
.sending-spinner .sk-circle7 {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
}
.sending-spinner .sk-circle8 {
    -webkit-transform: rotate(210deg);
    -ms-transform: rotate(210deg);
    transform: rotate(210deg);
}
.sending-spinner .sk-circle9 {
    -webkit-transform: rotate(240deg);
    -ms-transform: rotate(240deg);
    transform: rotate(240deg);
}
.sending-spinner .sk-circle10 {
    -webkit-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
}
.sending-spinner .sk-circle11 {
    -webkit-transform: rotate(300deg);
    -ms-transform: rotate(300deg);
    transform: rotate(300deg);
}
.sending-spinner .sk-circle12 {
    -webkit-transform: rotate(330deg);
    -ms-transform: rotate(330deg);
    transform: rotate(330deg);
}
.sending-spinner .sk-circle2:before {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}
.sending-spinner .sk-circle3:before {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
}
.sending-spinner .sk-circle4:before {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}
.sending-spinner .sk-circle5:before {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}
.sending-spinner .sk-circle6:before {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
}
.sending-spinner .sk-circle7:before {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
}
.sending-spinner .sk-circle8:before {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
}
.sending-spinner .sk-circle9:before {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
}
.sending-spinner .sk-circle10:before {
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
}
.sending-spinner .sk-circle11:before {
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
}
.sending-spinner .sk-circle12:before {
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
}

@-webkit-keyframes sk-circleBounceDelay {
    0%, 80%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    } 40% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@keyframes sk-circleBounceDelay {
    0%, 80%, 100% {
        -webkit-transform: scale(0);
        transform: scale(0);
    } 40% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }
}

@media (max-width: 449px)
and (orientation: portrait) {
    .form-legend {
        border-radius: 0;
    }
}
@media (min-width: 320px)
and (max-width: 767px)
and (orientation: landscape) {
    .form-legend {
        border-radius: 0;
    }
}
</style>
